(function($) {

  $(document).ready(function() {
    console.log('jsfile');

    

    if ( document.body.classList.contains('template-suffix-english') ) {
      document.querySelectorAll('.price-item').forEach(element => {
          element.innerHTML = element.innerHTML.replace(/₪/g, '$');
      });
    }

    var playButton = document.querySelectorAll('.banner_section .video-section__poster');
    if ( playButton ) {
      setTimeout(function() {
        playButton.forEach( elem => {
          elem.click();
          window.scrollBy(0,2);
        });
        document.addEventListener("scroll", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
        document.addEventListener("touchstart", (event) => {
          var videoelem = document.querySelectorAll('.banner_section video');
          videoelem.forEach( elem => {
            elem.play();
          });
        });
      }, 100);
    }
    
    function setTopHeader() {
      // let annBarHeight = document.querySelector('.announcement-bar-section')?.offsetHeight | 0;
      let header = document.querySelector('header.header');
      // let top = annBarHeight + headerHeight;
      
      let headerHeight = header.getBoundingClientRect();
      let bottomCoordinate = headerHeight.bottom;
      
      let menuDrawer = document.querySelector('#menu-drawer');
      menuDrawer.style.top = `${bottomCoordinate}px`;
    }
    setTopHeader();
    window.addEventListener( 'resize', setTopHeader );
    window.addEventListener( 'scroll', setTopHeader );
    
    // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this));
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(event) {
        this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
      }
    };
    window.customElements.define("free-shipping-bar", FreeShippingBar);
    
    $('.fake_search_action').on('click', function(e) {
      e.preventDefault();
      $('.header__search').trigger('click');
      $('.header__search > details').attr('open', true);
      $('.header__search > details summary').addClass('is-expanded');
    });

    $('.playpause').on('click', function () {
      if($(this).siblings("video").get(0).paused){        
        $(this).siblings("video").get(0).play();   
        $(this).fadeOut();
      } else {       
        $(this).siblings("video").get(0).pause();
        $(this).fadeIn();
      }
    });

    /*
    * animation counter
    */
    $(window).on('scroll', function(e) { 
      if ( $('.digit_animation').length < 1 ) return false;
        animationCountValue();
    });
    function animationCountValue() {
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
  
      var centerX = windowWidth / 2;
      var centerY = windowHeight / 2;
      
      var elementsInCenter = document.elementsFromPoint(centerX, centerY);
      let centeredProductId = $(elementsInCenter[0]).closest('.content-with-features');

      centeredProductId.find('.digit_animation').each(function() {
        if ( !$(this).hasClass('animated_count') ) {
          $(this).addClass('animated_count');
          let $this = $(this);
          let endValue = parseInt($this.attr('data-value'),10);
          let stepTimer = 100;
          let step = endValue / 20;
          
          if ( step < 1 ) {
            let coef = 1 / step;
            stepTimer = 100 * coef;
            step = 1;
          } 
          let intervalVal = setInterval(function() {
            let currentValue = parseInt( $this.text(), 10);
            
            if ( currentValue !== endValue ) {
              let newVal = currentValue > endValue ? endValue : currentValue + step;
              $this.text(parseInt(newVal));
            }
            if ( currentValue === endValue ) {
              clearInterval(intervalVal);
            }
          }, stepTimer);

          
        }
      });
    }
    
    $('#support_reason').select2();
    
   function setSlideHeight(that){
      $('.gallery-thumbs').css({height:'auto'});
      var currentSlide = that.activeIndex;
      var newHeight = $(that.slides[currentSlide]).height();

      $('.gallery-thumbs .swiper-wrapper,.gallery-thumbs .swiper-slide').css({ height : newHeight })
      that.update();
     }

    window.initJsSlideProduct = () => {

      function isVideoPlay(that) {
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active .deferred-media__poster')?.length > 0 ) {
          document.querySelector('.js-product-main-slider .swiper-slide-active .deferred-media__poster').click();
          
          setTimeout(() => {
            // console.log("Delayed for 1 second.");
             if ( document.querySelector('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
              let videos = document.querySelector('.js-product-main-slider .swiper-slide-active video');
              try {
                videos.play();
              } catch (error) {
                console.log(error);
              }
            }
          }, 1000);
        }
        if ( document.querySelectorAll('.js-product-main-slider .swiper-slide-active video')?.length > 0 ) {
          let video = document.querySelector('.js-product-main-slider .swiper-slide-active video');
          
          try {
            video.play();
          } catch (error) {
            console.log(error);
          }
        }
      }

      let containerProduct = document.querySelectorAll('.grid__item.product__media-wrapper');
      containerProduct.forEach(elem => {
        let thumbItem = elem.querySelector('.js-product-thumbnail-slider');
        let sliderThumbnail = new Swiper(thumbItem, {
          direction: 'vertical', // Set direction to vertical
          spaceBetween: 11,
          autoHeight: true,
          slidesPerView: 5,
          mousewheel: true,
          freeMode: true,
          on:{
            slideChangeTransitionEnd:function(){
              isVideoPlay(this);
            }
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 4,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 5,
            }
          }
        });
    
        let mainItem = elem.querySelector('.js-product-main-slider');
        let galleryMain = new Swiper(mainItem, {
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          thumbs: {
            swiper: sliderThumbnail
          },
          // autoHeight: true,
          on:{
            slideChangeTransitionEnd:function(){
              isVideoPlay(this);
            }
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1.3,
              centeredSlides: true,
              loop: false,
              // initialSlide: 1,
              spaceBetween: 15,
            },
            // when window width is >= 640px
            767: {
              slidesPerView: 1,
            }
          }
        });
      });
      
    }
    window.initJsSlideProduct();
  });
  
  (function(){
    document.addEventListener('DOMContentLoaded', function() {
      
      
      // console.log('jsfile');
      let warrantyData = document.querySelector('[data-warranty-info]');
      if ( warrantyData ) {
        let value = JSON.parse(JSON.parse(warrantyData.textContent));
        window.warranty = Object.values(value)
        // console.log(value);
      }
      document.body.addEventListener('change', function(e) { //form changes in live
         if (e.target.id === '65768-datetime' ) {
           let productName = document.querySelector('[id="65768-select-2"]');
           let targetDate = document.querySelector('[id="65768-datetime-1"]');
           let productSKU = document.querySelector('[id="hidden-1"]');
           let certificateDate = document.querySelector('[id="65768-datetime"]'); 

           if ( productName.value === '' ) return false;
           
           let filteredItems = window.warranty.filter(item => decodeURIComponent(item.name.replace(/\+/g, " ")) === productName.value);
           
           const oldDate = new Date(certificateDate.value);
           const date = new Date(certificateDate.value);
           date.setMonth(date.getMonth() + +filteredItems[0].warranty);
           if ( +filteredItems[0].warranty === 12 && date.getMonth() !== oldDate.getMonth() ) {
             date.setMonth(oldDate.getMonth());
           }
          
           const newDate = date.toISOString().split('T')[0];
           
           targetDate.value = newDate;
           const event = new Event('input', {bubbles: true,cancelable: true,});
           targetDate.dispatchEvent(event);
           let wrapperInput = targetDate.closest('.globo-form-control');
           wrapperInput?.querySelector('.material_outlined-label')?.classList.add('gfb__label__filled');

           productSKU.value = filteredItems[0].sku;
           productSKU.dispatchEvent(event);
         }
      });

      document.body.addEventListener('change', function(e) {
         if (e.target.id === '65768-select-2' ) {
           let productName = document.querySelector('[id="65768-select-2"]');
           let targetDate = document.querySelector('[id="65768-datetime-1"]');
           let certificateDate = document.querySelector('[id="65768-datetime"]'); 
           
           if ( certificateDate.value === '' ) return false;
           
           let productSKU = document.querySelector('[id="hidden-1"]');
           
           let filteredItems = window.warranty.filter(item => decodeURIComponent(item.name.replace(/\+/g, " ")) === productName.value);

           const oldDate = new Date(certificateDate.value);
           const date = new Date(certificateDate.value);
           date.setMonth(date.getMonth() + +filteredItems[0].warranty);
           if ( +filteredItems[0].warranty === 12 && date.getMonth() !== oldDate.getMonth() ) {
             date.setMonth(oldDate.getMonth());
           }
           const newDate = date.toISOString().split('T')[0];
           
           targetDate.value = newDate;
           const event = new Event('input', {bubbles: true,cancelable: true,});
           targetDate.dispatchEvent(event);
           let wrapperInput = targetDate.closest('.globo-form-control');
           wrapperInput?.querySelector('.material_outlined-label')?.classList.add('gfb__label__filled');

           productSKU.value = filteredItems[0].sku;
           productSKU.dispatchEvent(event);
         }
      });
  
      
      let footerMenus = document.querySelectorAll('.mobiel_arrow .footer-block__heading');
      footerMenus.forEach(function(elem) {
        elem.addEventListener('click', function(e) {
          e.preventDefault();
          elem.classList.toggle("active");
        });
      });
      
      // let fakeAddToCart = document.querySelectorAll('.fake_add_to_cart');
      // fakeAddToCart.forEach(function(elem) {
      //   elem.addEventListener('click', function(e) {
      //     e.preventDefault();
      //     let originalAddToCart = elem.closest('.product-card-wrapper').querySelector('.quick-add__submit');
      //     let soldOut = elem.closest('.product-card-wrapper').querySelector('.sold-out-message');
      //     originalAddToCart.click();
          
      //   });
      // });
      
      document.addEventListener('click', function(e) {
        if (event.target.classList.contains('fake_add_to_cart') || event.target.closest('.fake_add_to_cart')) {
           e.preventDefault();
          let originalAddToCart = event.target.closest('.product-card-wrapper').querySelector('.quick-add__submit');
          let soldOut = event.target.closest('.product-card-wrapper').querySelector('.sold-out-message');
          originalAddToCart.click();
        }
    
      });
      
      function setSlideHeight(that){
        var currentSlide = that.activeIndex + 2;
        var newHeight = that.slides[currentSlide].offsetHeight;
        console.log(that.slides[currentSlide]);
        let saleBanners = that.el.querySelectorAll('.sale_banner');
        saleBanners.forEach(function(element) {
          element.style.height = newHeight + 'px';
        });
        that.update();
       }
  
      /*
      * slider with products
      */
     let featurSlider = document.querySelector('.swiper-collection');
      if ( featurSlider ) {
        new Swiper(".swiper-collection", {
          slidesPerView: 2,
          spaceBetween: 10,
          // loop: true,
          // freeMode: {
          //   enabled: true,
          //   sticky: true,
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 10
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 10
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 3,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 4.2,
              // slidesPerView: "auto",
              spaceBetween: 30,
              initialSlide: 1,
              // centeredSlides: true,
              // loop: true
            }
          },
          on:{
              init: function(){
                setSlideHeight(this);
              }
            }
        });
      }
  
      /*
  * slider with products
  */
      let collectionsList = document.querySelector('.swiper-collections-list');
      if ( collectionsList ) {
        new Swiper(".swiper-collections-list", {
          slidesPerView: 2,
          spaceBetween: 24,
          freeMode: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 19
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 19
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 3,
              spaceBetween: 19
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 24,
            }
          }
        });
      }
  
       /*
      * slider for contacts columns
      */
     let multicolumn_swiper = document.querySelector('.multicolumn_swiper');
      if ( multicolumn_swiper ) {
        new Swiper(".multicolumn_swiper", {
           autoHeight: true,
          slidesPerView: 2,
          spaceBetween: 10,
          loopAdditionalSlides: 5,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 10
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 10
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 3,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 30,
              centeredSlides: true,
              freeMode: {
                enabled: true,
                sticky: true,
              },
            }
          },
        });
      }
      function galleryHeight() {
        let productSlider = document.querySelector('.template-product media-gallery .thumbnail-list');
        if ( productSlider ) {
          let mainMeida = document.querySelector('.template-product media-gallery .product__media-list');
          productSlider.style.maxHeight = `${mainMeida.offsetHeight}px`;
        }
      }
      galleryHeight();
      window.addEventListener('resize', function() {
        galleryHeight();
      });



      let menuses = document.querySelectorAll('.header__menu-item');
        menuses.forEach((elem)=> {
         elem.addEventListener('click', function(e) {
           fixSafariBug();
         });
      });
      function fixSafariBug() {
        let mega_menu_firin_wrapper = document.querySelectorAll('.mega_menu_firin_wrapper');
        mega_menu_firin_wrapper.forEach((elem)=> {
          let heightMax = 492;
          let insideItem = elem.querySelectorAll('.mega_menu_firin_wrapper > .item_custom_menu');
          let insideItemLength = insideItem.length;
          let firstPart = Math.floor(insideItemLength / 5);
          let secondPart = insideItemLength % 5;
          let lenghtResult = firstPart
          if ( secondPart > 0 ) {
            firstPart++; 
          }
          var marginLeft = 49;
          let widthElem = 353 + marginLeft;
          elem.closest('.mega_menu_firin_wrapper').style.minWidth = `${widthElem*firstPart}px`;
        });
      }

          
        class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.apiKey = this.dataset.apiKey;
    
    // Безопасное получение настроек зума из HTML-атрибутов data-*
    this.defaultZoom = parseInt(this.dataset.defaultZoom) || 12;
    this.focusedZoom = parseInt(this.dataset.focusedZoom) || 16;
    
    this.map = null;
    this.markers = [];
    this.stores = [];
    this.activeStoreId = null;
  }

  connectedCallback() {
    this.searchInput = this.querySelector('.firin-store-locator-search-input');
    this.storeItems = this.querySelectorAll('.ai-map-locations-item');
    this.noResults = this.querySelector('.firin-store-locator-no-results');
    this.mapContainer = this.querySelector('#firin-map');
    this.close_icon = this.querySelectorAll('.close_icon');
    
    this.collectStoreData();
    
    if (this.apiKey && this.apiKey.trim() !== '') {
      this.loadGoogleMapsScript();
    }

    this.setupEventListeners();
  }

  collectStoreData() {
    this.storeItems.forEach((item) => {
      const storeData = {
        id: item.dataset.storeId,
        name: item.dataset.storeName,
        address: item.dataset.storeAddress,
        phone: item.dataset.storePhone,
        lat: parseFloat(item.dataset.storeLat),
        lng: parseFloat(item.dataset.storeLng),
        element: item
      };
      this.stores.push(storeData);
    });
  }

  loadGoogleMapsScript() {
    // 1. Если API уже полностью загружен
    if (window.google && window.google.maps) {
      this.initMap();
      return;
    }

    // 2. Если API уже кем-то загружается прямо сейчас, подписываемся на окончание загрузки
    if (window.gmapsLoading) {
      document.addEventListener('gmaps:loaded', () => this.initMap());
      return;
    }

    // Флаг, блокирующий создание дубликатов тега скрипта
    window.gmapsLoading = true;

    // 3. Создаем единственный тег скрипта на странице
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      // Оповещаем все остальные компоненты на странице, что API готов
      // document.dispatchEvent(new CustomEvent('gmaps:loaded'));
      this.initMap();
    };
    
    script.onerror = () => {
      console.error('Не удалось загрузить Google Maps API.');
      window.gmapsLoading = false;
    };

    document.head.appendChild(script);
  }

  initMap() {
    if (!this.mapContainer || !this.stores.length) return;
    console.log(12321312312);
    // ИСПРАВЛЕНО: Ищем первый попавшийся магазин, у которого координаты корректно заданы
    const firstValidStore = this.stores.find(store => !isNaN(store.lat) && !isNaN(store.lng));
    
    // Если ни у одного магазина нет координат — карту инициализировать нет смысла
    if (!firstValidStore) {
      console.warn('StoreLocator: Ни у одного магазина не заданы координаты Lat/Lng.');
      return;
    }

    const mapOptions = {
      zoom: this.defaultZoom,
      center: { lat: firstValidStore.lat, lng: firstValidStore.lng },
      styles: []
    };

    this.map = new google.maps.Map(this.mapContainer, mapOptions);

    this.stores.forEach((store) => {
      // ИСПРАВЛЕНО: Строгая проверка на существование координат перед созданием маркера
      if (!isNaN(store.lat) && !isNaN(store.lng)) {
        const marker = new google.maps.Marker({
          position: { lat: store.lat, lng: store.lng },
          map: this.map,
          title: store.name
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `
            <div style="padding: 10px;">
              <h3 style="margin: 0 0 8px; font-size: 16px; font-weight: 600;">${store.name}</h3>
              ${store.address ? `<p style="margin: 0 0 4px; font-size: 14px;">${store.address}</p>` : ''}
              ${store.phone ? `<p style="margin: 0; font-size: 14px;">${store.phone}</p>` : ''}
            </div>
          `
        });

        marker.addListener('click', () => {
          this.closeAllInfoWindows();
          infoWindow.open(this.map, marker);
          this.highlightStoreInList(store.id);
        });

        this.markers.push({ marker, infoWindow, storeId: store.id });
      } else {
        // Логируем в консоль для отладки, у какого именно магазина пропущены данные
        console.warn(`Магазин "${store.name || store.id}" пропущен: неверные координаты lat/lng.`);
      }
    });

    this.fitMapToMarkers();
  }

  // fitMapToMarkers() {
  //   if (!this.map || !this.markers.length) return;

  //   const bounds = new google.maps.LatLngBounds();
  //   this.markers.forEach(({ marker }) => {
  //     bounds.extend(marker.getPosition());
  //   });
  //   this.map.fitBounds(bounds);
  // }
  fitMapToMarkers() {
    if (!this.map || !this.markers.length) return;

    const bounds = new google.maps.LatLngBounds();
    this.markers.forEach(({ marker }) => {
      bounds.extend(marker.getPosition());
    });

    // 1. Меняем границы карты под маркеры
    this.map.fitBounds(bounds);

    // 2. ИСПРАВЛЕНО: Ждем, пока карта применит новые границы, и ограничиваем зум
    google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
      // Если Google Maps после fitBounds сделал зум ближе (больше), чем ваш дефолтный (5)
      if (this.map.getZoom() > this.defaultZoom) {
        this.map.setZoom(this.defaultZoom); // Принудительно отдаляем до уровня страны
      }
    });
  }

  closeAllInfoWindows() {
    this.markers.forEach(({ infoWindow }) => {
      infoWindow.close();
    });
  }

  setupEventListeners() {
    if (this.searchInput) {
      
      this.searchInput.addEventListener('input', (e) => {
        this.handleSearch(e.target.value);
      });
    }

    this.storeItems.forEach((item) => {
      item.addEventListener('click', () => {
        const storeId = item.dataset.storeId;
        this.handleStoreClick(storeId);
      });
    });
    
    this.close_icon.forEach((close_item) => {
      

     

      close_item.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let item = close_item.closest('.ai-map-locations-item');
         if ( ! item ) return false;
        const storeId = item.dataset.storeId;
        this.handleStoreClick(storeId);
      });
    });
  }

  handleSearch(query) {
    const searchTerm = query.toLowerCase().trim();
    let visibleCount = 0;
    // debugger;
    this.storeItems.forEach((item) => {
      const name = (item.dataset.storeName || '').toLowerCase();
      const address = (item.dataset.storeAddress || '').toLowerCase();
      const phone = (item.dataset.storePhone || '').toLowerCase();

      const matches = name.includes(searchTerm) || 
                     address.includes(searchTerm) || 
                     phone.includes(searchTerm);

      if (matches || searchTerm === '') {
        item.classList.remove('hidden');
        visibleCount++;
      } else {
        item.classList.add('hidden');
      }
    });

    if (this.noResults) {
      this.noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    this.updateMapMarkers(searchTerm);
  }

  updateMapMarkers(searchTerm) {
    if (!this.map) return;

    const bounds = new google.maps.LatLngBounds();
    let hasVisibleMarkers = false;

    this.markers.forEach(({ marker, storeId }) => {
      const store = this.stores.find(s => s.id === storeId);
      if (!store) return;

      const name = (store.name || '').toLowerCase();
      const address = (store.address || '').toLowerCase();
      const phone = (store.phone || '').toLowerCase();

      const matches = searchTerm === '' || 
                     name.includes(searchTerm) || 
                     address.includes(searchTerm) || 
                     phone.includes(searchTerm);

      marker.setVisible(matches);

      if (matches) {
        bounds.extend(marker.getPosition());
        hasVisibleMarkers = true;
      }
    });

    if (hasVisibleMarkers) {
      this.map.fitBounds(bounds);
    }
  }

  highlightStoreInList(storeId) {
    this.storeItems.forEach((item) => {
      if (item.dataset.storeId === storeId) {
        item.classList.add('active');
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        item.classList.remove('active');
      }
    });
    this.activeStoreId = storeId;
  }

  // handleStoreClick(storeId) {
  //   this.highlightStoreInList(storeId);

  //   // ИСПРАВЛЕНО: Безопасный клик. Если у магазина нет маркера на карте (нет координат), метод просто не упадет.
  //   const targetMarkerSetup = this.markers.find(m => m.storeId === storeId);
    
  //   if (targetMarkerSetup && this.map) {
  //     const { marker, infoWindow } = targetMarkerSetup;
  //     marker.setVisible(true);
  //     this.closeAllInfoWindows();
  //     infoWindow.open(this.map, marker);
  //     this.map.setCenter(marker.getPosition());
  //     this.map.setZoom(this.focusedZoom);
  //   }
  // }
  handleStoreClick(storeId) {
    // Проверяем, не кликнули ли мы повторно по уже активной карточке
    const isReClickingActive = this.activeStoreId === storeId;

    if (isReClickingActive) {
      // 1. Убираем класс active со всех карточек
      this.storeItems.forEach(item => item.classList.remove('active'));
      
      // 2. Сбрасываем ID активного магазина
      this.activeStoreId = null;

      // 3. Закрываем балуны (infoWindows) на карте
      this.closeAllInfoWindows();

      // 4. Сбрасываем состояние карты к общему плану страны
      this.fitMapToMarkers();
      return; // Прерываем дальнейшее выполнение метода
    }

    // --- Логика для первого (обычного) клика на карточку ---
    this.highlightStoreInList(storeId);

    const targetMarkerSetup = this.markers.find(m => m.storeId === storeId);
    
    if (targetMarkerSetup && this.map) {
      const { marker, infoWindow } = targetMarkerSetup;
      
      // Гарантируем, что маркер виден на карте
      marker.setVisible(true);
      
      this.closeAllInfoWindows();
      infoWindow.open(this.map, marker);
      this.map.setCenter(marker.getPosition());
      this.map.setZoom(this.focusedZoom);
    }
  }

}

// Безопасная регистрация кастомного элемента
if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}
    
    }, false);
  })();
})(window.jQuery)
  

